var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { languageSelectors, languageActions } from 'redux/ducks/language';
import { ELSLoggingService, ELSPageLoader } from '@els/els-ui-common-react';
import { Language } from 'constants/app.constant';
var loadLanguageByLocale = function (locale) {
    if (locale === void 0) { locale = Language.DEFAULT_LOCALE; }
    return import("../../../localization/".concat(locale, ".json"));
};
var useLanguageLoader = function () {
    var _a;
    var locale = useSelector(languageSelectors.getLocale);
    var formattedMessages = useSelector(languageSelectors.getUsingFormattedMessages);
    var dispatch = useDispatch();
    var _b = useState((_a = {},
        _a[locale] = formattedMessages,
        _a)), messages = _b[0], setMessages = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var safeMessages = useMemo(function () {
        var currentMessages = messages[locale] || formattedMessages || {};
        if (!currentMessages || typeof currentMessages !== 'object') {
            return {};
        }
        return currentMessages;
    }, [messages, locale, formattedMessages]);
    useEffect(function () {
        if (!locale || messages[locale])
            return;
        setLoading(true);
        loadLanguageByLocale(locale)
            .then(function (loadedMessages) {
            var _a;
            var messageData = loadedMessages.default || loadedMessages;
            dispatch(languageActions.setLocale(locale));
            dispatch(languageActions.setFormattedMessages((_a = {}, _a[locale] = messageData, _a)));
            setMessages(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[locale] = messageData, _a)));
            });
        })
            .catch(function (error) {
            ELSLoggingService.error("Failed to load locale ".concat(locale, ":"), error);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [locale, messages, dispatch]);
    return { locale: locale, safeMessages: safeMessages, loading: loading };
};
var LanguageProvider = function (_a) {
    var children = _a.children;
    var _b = useLanguageLoader(), locale = _b.locale, safeMessages = _b.safeMessages, loading = _b.loading;
    if (loading) {
        return <ELSPageLoader />;
    }
    return (<IntlProvider locale={locale || Language.DEFAULT_LOCALE} messages={safeMessages} defaultLocale={Language.DEFAULT_LOCALE} onError={function (error) {
            if (process.env.NODE_ENV !== 'production') {
                ELSLoggingService.warn('IntlProvider error:', error);
            }
        }}>
      {children}
    </IntlProvider>);
};
export default LanguageProvider;
